export default __webpack_public_path__ + "static/media/tailwind.bce5aaa2.png";